import { render, staticRenderFns } from "./BowCTABlockCenter.vue?vue&type=template&id=57d3898f&"
import script from "./BowCTABlockCenter.vue?vue&type=script&lang=js&"
export * from "./BowCTABlockCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowCTABlock: require('/workspace/components/organisms/BowCTABlock/BowCTABlock.vue').default})
